const PlusIcon = ({ className = '' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    className={className}
  >
    <path
      d='M23.4326 16.6216H7.86506C7.33317 16.6216 6.89209 16.1806 6.89209 15.6487C6.89209 15.1168 7.33317 14.6757 7.86506 14.6757H23.4326C23.9645 14.6757 24.4056 15.1168 24.4056 15.6487C24.4056 16.1806 23.9645 16.6216 23.4326 16.6216Z'
      fill='#1E2B55'
    />
    <path
      d='M15.6488 24.4054C15.1169 24.4054 14.6758 23.9643 14.6758 23.4324V7.86488C14.6758 7.33299 15.1169 6.89191 15.6488 6.89191C16.1806 6.89191 16.6217 7.33299 16.6217 7.86488V23.4324C16.6217 23.9643 16.1806 24.4054 15.6488 24.4054Z'
      fill='#1E2B55'
    />
  </svg>
);
export default PlusIcon;
